import { tabDestination } from './keyboard';

let sequence = 0;
// Upgrade the readable, static diagrams only after the controls are ready.
export function initShowcase(root: HTMLElement) {
    if (root.classList.contains('is-interactive') || root.classList.contains('stgb-columns-showcase--editor')) return;
    const tablist = root.querySelector<HTMLElement>('.stgb-columns-showcase__tabs');
    const tabs = Array.from(root.querySelectorAll<HTMLButtonElement>('[data-showcase-tab]'));
    const panels = Array.from(root.querySelectorAll<HTMLElement>('[data-showcase-panel]'));
    if (!tablist || !tabs.length || panels.length !== tabs.length) return;
    let prefix: string;
    do { prefix = 'stgb-columns-demo-' + (++sequence); }
    while (document.getElementById(prefix + '-tab-0') || document.getElementById(prefix + '-panel-0'));
    const initial = Number(root.dataset.showcaseInitial);
    let current = Number.isInteger(initial) && initial >= 0 && initial < tabs.length ? initial : 0;

    function select(index: number, focus = false) {
        current = index;
        tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === current));
            tab.tabIndex = i === current ? 0 : -1;
            panels[i].hidden = i !== current;
        });
        if (focus) tabs[index].focus();
    }
    tablist.setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
        tab.id = prefix + '-tab-' + index;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', prefix + '-panel-' + index);
        panels[index].id = prefix + '-panel-' + index;
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', (event) => {
            const next = tabDestination(event.key, current, tabs.length, getComputedStyle(root).direction === 'rtl');
            if (next === undefined) return;
            event.preventDefault();
            select(next, true);
        });
    });
    select(current);
    root.classList.add('is-interactive');
}
